import { useQuery } from "@tanstack/react-query";

import { medicationRequestQueriesStore } from "../api";

export const useDelayedRefillRequests = () => {
  return useQuery(
    medicationRequestQueriesStore.medicationRequest.list._ctx.delayed,
  );
};
